<template lang="pug">
div.custom
  h2.custom__title.custom__title--purple(
    v-if="block.text"
    v-html="block.text")
  a.custom__image-block(
    v-if="block.image"
    :href='block.image.link'
    target="_blank"
    rel="noopener")
      picture
        source(
          v-if="block.image.imgSrc"
          v-for="image in block.image.imgSrc"
          :key="image.src"
          :srcset="`/services/${image.src}`"
          :type="image.type")
        img.custom__image(:src="`/services/${block.image.fallbackSrc}`")
</template>

<script>
export default {
  name: 'CustomBlockComponent',
  props: {
    block: {
      type: Object,
      default: () => {},
    }
  },
}
</script>

<style lang='scss' scoped>
.custom {
  &__title {
    text-transform: uppercase;
    color: $primary;
    font-size: 1.25rem;
    margin-bottom: 3rem;

    &--purple {
      color: $purple;
      margin-bottom: 2rem;
    }
  }

  &__image-block,
  &__image {
    display: block;
    width: 100%;
  }
}
</style>
